import angular from 'angular'

import component from './document-consent.component'

let module = angular.module('documentConsent', [])

.component('documentConsent', component)

.name

export default module



// WEBPACK FOOTER //
// ./src/app/common/document-consent/index.js